import React from 'react';
import { Container, Typography, Box, Paper, Divider } from '@mui/material';
import PublicHeader from '../components/PublicHeader';
import Footer from '../components/Footer';

const PURPLE = '#00F1A7';

export default function TermosUso() {
  return (
    <>
      <PublicHeader />
      <Box sx={{ bgcolor: '#f8f9fa', minHeight: '70vh', py: { xs: 4, md: 6 } }}>
        <Container maxWidth="md">
          <Paper sx={{ p: { xs: 3, md: 5 }, borderRadius: 3 }}>
            <Typography variant="h4" sx={{ fontWeight: 800, mb: 1, color: PURPLE }}>
              Termos de Uso
            </Typography>
            <Typography variant="body2" color="text.secondary" sx={{ mb: 4 }}>
              Última atualização: 20 de Junho de 2026
            </Typography>

            <Typography variant="h6" sx={{ fontWeight: 700, mt: 3, mb: 1 }}>
              1. Aceitação dos Termos
            </Typography>
            <Typography variant="body1" color="text.secondary" sx={{ lineHeight: 1.8 }}>
              Ao acessar ou utilizar a plataforma ConectaChurch (&ldquo;Plataforma&rdquo;), disponibilizada pela SmyrnaCore Tecnologia
              (CNPJ 66.330.452/0001-40), você (&ldquo;Usuário&rdquo; ou &ldquo;Igreja&rdquo;) concorda integralmente com estes
              Termos de Uso. Caso não concorde com qualquer disposição aqui presente, você não deve utilizar a Plataforma.
            </Typography>
            <Typography variant="body1" color="text.secondary" sx={{ lineHeight: 1.8, mt: 1 }}>
              A SmyrnaCore reserva-se o direito de alterar estes Termos a qualquer momento, mediante comunicação prévia por
              e-mail ou por aviso na Plataforma. O uso continuado após a modificação dos Termos implica na aceitação das novas
              condições.
            </Typography>

            <Divider sx={{ my: 3 }} />

            <Typography variant="h6" sx={{ fontWeight: 700, mb: 1 }}>
              2. Descrição do Serviço
            </Typography>
            <Typography variant="body1" color="text.secondary" sx={{ lineHeight: 1.8 }}>
              A ConectaChurch é uma plataforma SaaS (Software as a Service) de gestão eclesiástica, que oferece funcionalidades para
              administração de secretaria, consolidação de novos convertidos, gestão de cursos e treinamentos, discipulado,
              grupos de crescimento (GCs), jornada do membro, voluntariado, notificações, controle financeiro e demais módulos
              disponíveis conforme o plano contratado.
            </Typography>
            <Typography variant="body1" color="text.secondary" sx={{ lineHeight: 1.8, mt: 1 }}>
              A Plataforma é oferecida no modelo &ldquo;as is&rdquo; (como está), e a SmyrnaCore pode, a qualquer momento,
              adicionar, remover ou modificar funcionalidades, desde que não haja prejuízo substancial às funcionalidades
              essenciais do plano contratado.
            </Typography>

            <Divider sx={{ my: 3 }} />

            <Typography variant="h6" sx={{ fontWeight: 700, mb: 1 }}>
              3. Cadastro e Responsabilidades do Usuário
            </Typography>
            <Typography variant="body1" color="text.secondary" sx={{ lineHeight: 1.8 }}>
              Para utilizar a Plataforma, a Igreja deverá realizar cadastro fornecendo informações verdadeiras, precisas e
              completas, incluindo nome da igreja, CNPJ (quando aplicável), endereço, e-mail e telefone de contato do
              responsável legal.
            </Typography>
            <Typography variant="body1" color="text.secondary" sx={{ lineHeight: 1.8, mt: 1 }}>
              São responsabilidades do Usuário:
            </Typography>
            <Box component="ul" sx={{ mt: 0.5, pl: 2.5, color: 'text.secondary', lineHeight: 2 }}>
              <li>Manter a confidencialidade de suas credenciais de acesso (login e senha)</li>
              <li>Garantir que os dados inseridos na Plataforma (membros, finanças, frequências etc.) são verídicos e estão em conformidade com a LGPD</li>
              <li>Obter consentimento dos membros cujos dados são armazenados na Plataforma, conforme a Lei Geral de Proteção de Dados (Lei 13.709/2018)</li>
              <li>Não utilizar a Plataforma para fins ilícitos ou contrários à moral e aos bons costumes</li>
              <li>Não tentar burlar, engenhar reversamente ou comprometer a segurança da Plataforma</li>
            </Box>

            <Divider sx={{ my: 3 }} />

            <Typography variant="h6" sx={{ fontWeight: 700, mb: 1 }}>
              4. Planos, Pagamentos e Renovações
            </Typography>
            <Typography variant="body1" color="text.secondary" sx={{ lineHeight: 1.8 }}>
              A ConectaChurch oferece planos de assinatura com valores e funcionalidades descritos na página de planos da Plataforma.
              Os planos disponíveis são:
            </Typography>
            <Box component="ul" sx={{ mt: 0.5, pl: 2.5, color: 'text.secondary', lineHeight: 2 }}>
              <li><strong>Semente</strong> — Gratuito, com funcionalidades limitadas</li>
              <li><strong>Essencial</strong> — R$97/mês</li>
              <li><strong>Crescimento</strong> — R$197/mês</li>
              <li><strong>Pleno</strong> — R$297/mês</li>
            </Box>
            <Typography variant="body1" color="text.secondary" sx={{ lineHeight: 1.8, mt: 1 }}>
              Os pagamentos são processados exclusivamente via Stripe, plataforma de pagamentos internacional com padrão PCI-DSS
              de segurança. A ConectaChurch não armazena dados de cartão de crédito em seus servidores.
            </Typography>
            <Typography variant="body1" color="text.secondary" sx={{ lineHeight: 1.8, mt: 1 }}>
              As assinaturas são renovadas automaticamente a cada ciclo (mensal), salvo cancelamento expresso pelo Usuário com
              pelo menos 24 horas de antecedência do vencimento. O Usuário pode cancelar a qualquer momento pela Plataforma,
              e o acesso permanecerá ativo até o fim do ciclo já pago.
            </Typography>

            <Divider sx={{ my: 3 }} />

            <Typography variant="h6" sx={{ fontWeight: 700, mb: 1 }}>
              5. Período de Teste (Trial)
            </Typography>
            <Typography variant="body1" color="text.secondary" sx={{ lineHeight: 1.8 }}>
              Toda nova igreja tem direito a um período de teste gratuito de 7 (sete) dias corridos no plano Semente, contados
              a partir da data de cadastro. Durante o período de teste, a igreja terá acesso às funcionalidades do plano
              Semente sem qualquer custo.
            </Typography>
            <Typography variant="body1" color="text.secondary" sx={{ lineHeight: 1.8, mt: 1 }}>
              Ao final do período de teste, a igreja poderá optar por migrar para um plano pago ou continuar no plano Semente
              gratuito com funcionalidades reduzidas. Caso não seja feita a migração, o acesso às funcionalidades premium será
              automaticamente suspenso.
            </Typography>

            <Divider sx={{ my: 3 }} />

            <Typography variant="h6" sx={{ fontWeight: 700, mb: 1 }}>
              6. Cancelamento e Reembolso
            </Typography>
            <Typography variant="body1" color="text.secondary" sx={{ lineHeight: 1.8 }}>
              O Usuário pode solicitar o cancelamento da assinatura a qualquer momento diretamente pela Plataforma, na seção de
              configurações da igreja. O cancelamento será efetivado ao final do ciclo de cobrança corrente, e nenhum valor
              adicional será cobrado.
            </Typography>
            <Typography variant="body1" color="text.secondary" sx={{ lineHeight: 1.8, mt: 1 }}>
              Em caso de solicitação de reembolso, a ConectaChurch analisará o pedido conforme os seguintes critérios:
            </Typography>
            <Box component="ul" sx={{ mt: 0.5, pl: 2.5, color: 'text.secondary', lineHeight: 2 }}>
              <li>Reembolso integral se solicitado em até 7 (sete) dias corridos após o pagamento, desde que o uso da Plataforma não tenha sido substancial</li>
              <li>Após 7 dias do pagamento, não há direito a reembolso, salvo em casos de indisponibilidade prolongada da Plataforma por falha comprovada da SmyrnaCore</li>
              <li>O reembolso será processado em até 15 (quinze) dias úteis pela mesma forma de pagamento utilizada</li>
              <li>Igrejas bonificadas (que receberam acesso gratuito estendido) não geram direito a qualquer tipo de reembolso ou indenização</li>
            </Box>

            <Divider sx={{ my: 3 }} />

            <Typography variant="h6" sx={{ fontWeight: 700, mb: 1 }}>
              7. Propriedade Intelectual
            </Typography>
            <Typography variant="body1" color="text.secondary" sx={{ lineHeight: 1.8 }}>
              Todos os direitos de propriedade intelectual sobre a Plataforma ConectaChurch, incluindo código-fonte, design,
              logotipos, marcas, textos, gráficos e demais elementos, são de titularidade exclusiva da SmyrnaCore Tecnologia.
            </Typography>
            <Typography variant="body1" color="text.secondary" sx={{ lineHeight: 1.8, mt: 1 }}>
              O Usuário não adquire qualquer direito de propriedade sobre a Plataforma, sendo-lhe concedida apenas uma licença
              limitada, não exclusiva, não transferível e revogável para uso da Plataforma durante a vigência da assinatura.
              É expressamente vedado reproduzir, modificar, distribuir, vender, alugar ou criar obras derivadas da Plataforma
              sem autorização prévia por escrito da SmyrnaCore.
            </Typography>
            <Typography variant="body1" color="text.secondary" sx={{ lineHeight: 1.8, mt: 1 }}>
              Os dados inseridos pelo Usuário na Plataforma (membros, finanças, frequências etc.) permanecem de propriedade
              exclusiva da Igreja titular da conta. A SmyrnaCore não reivindica propriedade sobre os dados do Usuário.
            </Typography>

            <Divider sx={{ my: 3 }} />

            <Typography variant="h6" sx={{ fontWeight: 700, mb: 1 }}>
              8. Limitação de Responsabilidade
            </Typography>
            <Typography variant="body1" color="text.secondary" sx={{ lineHeight: 1.8 }}>
              A ConectaChurch é fornecida &ldquo;como está&rdquo;, sem garantias de qualquer natureza, expressas ou implícitas. A
              SmyrnaCore não garante que a Plataforma estará livre de interrupções, erros ou indisponibilidades temporárias.
            </Typography>
            <Typography variant="body1" color="text.secondary" sx={{ lineHeight: 1.8, mt: 1 }}>
              Em nenhuma hipótese a SmyrnaCore será responsável por danos indiretos, incidentais, especiais ou consequenciais,
              incluindo perda de dados, lucros cessantes ou interrupção de atividades, decorrentes do uso ou da impossibilidade
              de uso da Plataforma, ainda que tenha sido alertada sobre a possibilidade de tais danos.
            </Typography>
            <Typography variant="body1" color="text.secondary" sx={{ lineHeight: 1.8, mt: 1 }}>
              A responsabilidade total da SmyrnaCore, em qualquer circunstância, limitar-se-á ao valor total pago pelo Usuário
              nos 3 (três) meses imediatamente anteriores ao evento que deu causa à reclamação.
            </Typography>
            <Typography variant="body1" color="text.secondary" sx={{ lineHeight: 1.8, mt: 1 }}>
              A SmyrnaCore não se responsabiliza pelo conteúdo inserido pelo Usuário na Plataforma, cabendo exclusivamente ao
              Usuário garantir a licitude, veracidade e conformidade dos dados com a legislação aplicável.
            </Typography>

            <Divider sx={{ my: 3 }} />

            <Typography variant="h6" sx={{ fontWeight: 700, mb: 1 }}>
              9. Lei Aplicável e Foro
            </Typography>
            <Typography variant="body1" color="text.secondary" sx={{ lineHeight: 1.8 }}>
              Estes Termos de Uso são regidos pelas leis da República Federativa do Brasil. Fica eleito o foro da Comarca de
              Recife, Estado de Pernambuco, para dirimir quaisquer controvérsias oriundas destes Termos, com renúncia expressa
              a qualquer outro, por mais privilegiado que seja.
            </Typography>

            <Divider sx={{ my: 3 }} />

            <Typography variant="h6" sx={{ fontWeight: 700, mb: 1 }}>
              10. Contato
            </Typography>
            <Typography variant="body1" color="text.secondary" sx={{ lineHeight: 1.8 }}>
              Para esclarecimentos sobre estes Termos de Uso, entre em contato conosco:
            </Typography>
            <Box component="ul" sx={{ mt: 0.5, pl: 2.5, color: 'text.secondary', lineHeight: 2 }}>
              <li>E-mail: contato@smyrnacore.com.br</li>
              <li>WhatsApp: (81) 99600-1383</li>
              <li>Endereço: Recife, Pernambuco, Brasil</li>
            </Box>

            <Typography variant="body2" color="text.secondary" sx={{ mt: 4, textAlign: 'center' }}>
              SmyrnaCore Tecnologia LTDA — CNPJ 66.330.452/0001-40
            </Typography>
          </Paper>
        </Container>
      </Box>
      <Footer />
    </>
  );
}
